import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaCheckCircle, FaDownload, FaFileInvoice, FaHome } from 'react-icons/fa';
import axios from 'axios';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const paymentId = searchParams.get('payment_id');
  const orderId = searchParams.get('order_id');
  const [invoiceUrl, setInvoiceUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!paymentId || !orderId) {
      toast.error('Invalid payment confirmation');
      navigate('/pricing');
      return;
    }

    const generateInvoice = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/invoice/generate`,
          { paymentId, orderId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        const fullInvoiceUrl = `${process.env.REACT_APP_API_BASE_URL}${response.data.invoiceUrl}`;
        setInvoiceUrl(fullInvoiceUrl);
      } catch (error) {
        console.error('Error generating invoice:', error);
        toast.error('Failed to generate invoice');
      } finally {
        setIsLoading(false);
      }
    };

    generateInvoice();
  }, [paymentId, orderId, navigate]);

  const downloadInvoice = () => {
    if (!invoiceUrl) return;
    const link = document.createElement('a');
    link.href = invoiceUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    const filename = invoiceUrl.split('/').pop();
    link.download = filename || `invoice_${orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <FaCheckCircle className="success-icon" />
        <h2>Payment Successful!</h2>
        <p className="thank-you-text">Thank you for your purchase.</p>

        <div className="payment-details">
          <p><strong>Order ID:</strong> {orderId}</p>
          <p><strong>Payment ID:</strong> {paymentId}</p>
        </div>

        <div className="invoice-actions">
          {isLoading ? (
            <button className="invoice-button invoice-download" disabled>
              <FaFileInvoice /> Preparing Invoice...
            </button>
          ) : (
            <button 
              className="invoice-button invoice-download"
              onClick={downloadInvoice}
              disabled={!invoiceUrl}
            >
              <FaDownload /> Download Invoice
            </button>
          )}

          <button
            className="invoice-button invoice-view"
            onClick={() => navigate('/Invoice')}
          >
            <FaFileInvoice /> View All Invoices
          </button>

          <button
            className="invoice-button invoice-dashboard"
            onClick={() => navigate('/pricing')}
          >
            <FaHome /> Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
export default PaymentSuccess;
